import algoliasearch from 'algoliasearch';
import aa from 'search-insights';

const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY;

aa('init', { appId, apiKey });

export default algoliasearch(appId, apiKey);
export { aa };
